import { URLS } from 'market-view-ui/constants';

export function apiURL() {
  return URLS[window.location.origin] || URLS['default'];
}
